<template>
    <form autocomplete="off"
        @submit.prevent="handleSubmit"
    >
        <input autocomplete="off" name="hidden" type="text" style="display:none;">
        <div class="form-group">
            <label>Aktywny</label>
            <div>
                <input
                    type="checkbox"
                    true-value="1"
                    false-value="0"
                    class="form-control-checkbox"
                    name="active"
                    v-model="user.active"
                    id="active"
                />
            </div>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('name')}"
        >
            <label>
                Imię i nazwisko
            </label>
            <input
                type="text"
                class="form-control"
                name="name"
                v-model="user.name"
                v-validate="'required'"
            >
            <small
                v-show="errors.has('name')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('email')}"
        >
            <label>
                E-mail
            </label>
            <input
                type="text"
                class="form-control"
                name="email"
                v-model="user.email"
                v-validate="'required'"
            >
            <small
                v-show="errors.has('email')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('phone')}"
        >
            <label>
                Telefon
            </label>
            <input
                type="text"
                class="form-control"
                name="phone"
                v-model="user.phone"
                v-validate="'required'"
            >
            <small
                v-show="errors.has('phone')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('password')}"
        >
            <label>
                Hasło
            </label>
            <input
                type="password"
                class="form-control"
                name="password"
                v-model="user.password"
                v-validate="'required|min:6'"
            >
            <small
                v-show="errors.has('password')"
                class="text-danger"
            >
                {{ errors.first('password') }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('re_password')}"
        >
            <label>
                Powtórz hasło
            </label>
            <input
                type="password"
                class="form-control"
                name="re_password"
                v-model="user.re_password"
                v-validate="'required'"
            >
            <small
                v-show="errors.has('re_password')"
                class="text-danger"
            >
                {{ errors.first('re_password') }}
            </small>
        </div>
        <div
            class="form-group"
            :class="{'has-error': errors.has('role_id')}"
        >
            <label>
                Rola
            </label>
            <select
                class="form-control m-b"
                name="faq_type_id"
                v-validate="'required'"
                v-model="user.role_id"
            >
                <option
                    v-for="( role, i ) in rolesList"
                    :key="i"
                    :value=" role.id "
                >
                    {{ role.name }}
                </option>
            </select>
            <small
                v-show="errors.has('role_id')"
                class="text-danger"
            >
                {{ $t( 'field_required' ) }}
            </small>
        </div>

        <div class="hr-line-dashed"></div>
        <div class="form-group row">
            <div class="col-sm-4 col-sm-offset-2">
                <button class="btn btn-primary btn-sm" type="submit">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'usersAddForm',
    data() {
        return {
            title: 'Dodaj użytkownika',
            loading: false,
            user: {
                active: false,
                name: '',
                email: '',
                phone: '',
                password: '',
                re_password: ''
            },
            rolesList: []
        }
    },
    created() {
        Promise.all( [
            this.getRolesList()
        ] ).then( () => {
            this.$emit( 'loading', false )
        } )
        this.user.role_id = this.ROLE_WORKER
    },
    methods: {
        async getRolesList() {
            await this.$http.get( 'dictionary/roles' )
                .then( resp => {
                    this.rolesList = resp.data
                } )
        },
        handleSubmit() {
            this.$validator.validateAll().then( result => {
                if ( result ) {
                    this.$emit( 'loading', true )
                    this.$http.post( 'users', this.user )
                        .then( () => {
                            this.$emit( 'loading', false )
                            this.$toastr.success( 'Użytkownik został dodany' )
                            this.$router.push( { name: 'users' } )
                        } )
                        .catch( err => {
                            this.$toastr.error( this.convertErrorToPopupText( err.data ) )
                            this.$emit( 'loading', false )
                        } )
                }
            } )
        },
        convertErrorToPopupText( error ) {
            const text = []
            if ( error !== undefined && error !== '' ) {
                text.push( '<ul>' )
                for ( const [ key, value ] of Object.entries( error ) ) {
                    text.push( `<li> ${value.join( ' ' )} </li>` )
                }
                text.push( '</ul>' )
            }
            return text.join( '' )
        }
    }
}
</script>

